import type { HTMLAttributes, ElementType, FC } from 'react';

import useClassy from '@core/hooks/useClassy';
import pxOrCssValue from '@core/utils/pxOrCssValue';

import classes from './style.module.scss';

export type SheenBoxProps = HTMLAttributes<HTMLElement> & {
  tag?: ElementType;
  bezier?: 'ease-in-out' | 'ease-in' | 'ease-out' | 'ease' | 'linear';
  sheen?: string[];
  duration?: `${number}ms` | `${number}s`;
  opacity?: number | `${number}`;
  width?: number | string;
};

const SheenBox: FC<SheenBoxProps> = ({
  tag: Tag = 'div',
  className,
  sheen = ['cyan', 'magenta', 'yellow'],
  bezier = 'linear',
  duration = '12s',
  opacity = 1,
  width = 1,
  style,
  ...props
}) => {
  const bem = useClassy(classes, 'SheenBox');
  return (
    <Tag
      {...props}
      className={bem('&', className)}
      style={{
        ...style,
        '--opacity': opacity,
        '--width': pxOrCssValue(width),
        '--duration': duration,
        '--color': [sheen].flat().join(),
        '--bezier': bezier,
      }}
    />
  );
};

export default SheenBox;
